
<p-selectbutton [options]="filterByOptions" [(ngModel)]="filterBy" class="spaceAbove"></p-selectbutton>

<div class="spaceAbove centerDiv" >
    <panel *ngIf="filterBy=='state'">
        <p-select [options]="stateNames" [(ngModel)]="selectedState" appendTo="body" filter=true></p-select>
    </panel>

    <panel *ngIf="filterBy=='eventType'" class="spaceAbove">
        <p-multiselect [options]="eventTypes" [(ngModel)]="selectedEventTypes" optionLabel="name" optionValue="name" appendTo="body" filter=true></p-multiselect>
		<button pButton type="button" icon="pi pi-refresh"
          (click)="resetDefaultEventTypes()"
          title="Reset to default event types; contact TriLynx to add to default event types" class="p-button-sm smallSpaceLeft"></button>
        <!--
        <p-listbox [options]="eventTypes" [(ngModel)]="selectedEventTypes" optionLabel="name" optionValue="name" [multiple]="true" [checkbox]="true" filter=true></p-listbox>
        -->
    </panel>
</div>

<div class="centerDiv spaceBetween spaceAbove">
    <p-button (click)="apply()">Apply</p-button>
    <p-button (click)="cancel()">Cancel</p-button>
</div>